module.exports = __webpack_public_path__ + "static/energy_11-5763b8921e18c1d1e46dbb0497df0021.jpg";